import React from 'react'
import { createRoot } from 'react-dom/client'

import { BrowserRouter } from 'react-router-dom'
import { RouterThree } from './routes'
import { User } from './interfaces'
import { Layout } from './styles/layout'
import { CommonProviders, LastSelectedMedicalViewProvider } from '~/context'

declare global {
  interface Window {
    renderHStory: (containerId: string, history: History, userSession: User) => void
    unmountHStory: (containerId: string) => void
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
window.renderHStory = (containerId: string, history: History, userSession: User) => {
  const rootElement = document.getElementById(containerId)
  const root = createRoot(rootElement as Element)

  if (userSession) {
    root.render(
      <React.StrictMode>
        <CommonProviders user={userSession}>
          <BrowserRouter>
            <Layout>
              <LastSelectedMedicalViewProvider>
                <RouterThree />
              </LastSelectedMedicalViewProvider>
            </Layout>
          </BrowserRouter>
        </CommonProviders>
      </React.StrictMode>
    )
  } else {
    root.render(<h1> Esse conteúdo não pode ser acessado diretamente</h1>)
  }
}

window.unmountHStory = (containerId: string) => {
  const rootElement = document.getElementById(containerId)
  const root = createRoot(rootElement as Element)
  root.unmount()
}

if (!document.getElementById('HStory-container') && process.env.NODE_ENV === 'dev') {
  const rootElement = document.getElementById('root')
  const root = createRoot(rootElement as Element)
  root.render(
    <BrowserRouter>
      <CommonProviders>
        <RouterThree />
      </CommonProviders>
    </BrowserRouter>
  )
}
